import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/refresh.png';
const _withScopeId = n => (_pushScopeId("data-v-1228a786"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "common-page2"
};
const _hoisted_2 = {
  key: 0,
  class: "title_boxs"
};
const _hoisted_3 = {
  class: "text_title1"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "i_s"
}, null, -1));
const _hoisted_5 = {
  class: "text_title2"
};
const _hoisted_6 = {
  key: 1,
  class: "title_boxs"
};
const _hoisted_7 = {
  class: "text_title1"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "i_s"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "refresh_img",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text_title_2"
}, "刷新", -1));
const _hoisted_11 = [_hoisted_9, _hoisted_10];
const _hoisted_12 = {
  class: "tag_t"
};
const _hoisted_13 = {
  class: "time_picker"
};
const _hoisted_14 = {
  class: "box_chats"
};
import { ref, watch } from "vue";
import AiItem from "@/components/ai/index.vue";
import allchat from "./allchat.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    cha_id: String,
    types: Number,
    dialog_s: Boolean,
    item_chats: Object,
    from: String,
    page_f: Number
  },
  setup(__props) {
    const props = __props;
    const ai_show = ref(false);
    const triggerButton = ref(null);
    const set_shows = () => {
      ai_show.value = true;
    };
    const beforeEnter = el => {
      const rect = triggerButton.value.getBoundingClientRect();
      el.style.transformOrigin = `${rect.left + rect.width / 2}px ${rect.top + rect.height / 2}px`;
    };
    const enter = (el, done) => {
      el.style.opacity = 0;
      el.style.transform = "scale(0)";
      el.style.transition = "all 0.3s ease";
      requestAnimationFrame(() => {
        el.style.opacity = 1;
        el.style.transform = "scale(1)";
        done();
      });
    };
    const leave = (el, done) => {
      el.style.opacity = 0;
      el.style.transform = "scale(0)";
      el.style.transition = "all 0.3s ease";
      setTimeout(done, 300);
    };
    const closeAi = () => {
      ai_show.value = false;
    };
    const selectedDateRange = ref([]);
    const tag_list = ref([{
      id: 1,
      name: "全部"
    }, {
      id: 2,
      name: "图片及视频"
    }, {
      id: 3,
      name: "文件"
    }, {
      id: 4,
      name: "链接"
    }, {
      id: 5,
      name: "语音"
    }]);
    const activeName = ref(1);
    watch(() => props.cha_id, newValue => {
      if (newValue) {
        selectedDateRange.value = [];
        activeName.value = 1;
      }
    });
    watch(() => props.types, newValue => {
      if (newValue) {
        selectedDateRange.value = [];
        activeName.value = 1;
      }
    });
    const allContainer = ref(null);
    const get_refresh = () => {
      if (allContainer.value) {
        allContainer.value.get_list();
      }
    };
    const handleClick = (tab, event) => {};
    return (_ctx, _cache) => {
      const _component_TimePicker = _resolveComponent("TimePicker");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.item_chats && __props.types == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.item_chats.name) + "（" + _toDisplayString(__props.item_chats.user_num) + "） ", 1), _hoisted_4, _createElementVNode("div", _hoisted_5, "群主：" + _toDisplayString(__props.item_chats.owner_name), 1)])) : _createCommentVNode("", true), __props.item_chats && __props.types == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createTextVNode(_toDisplayString(__props.item_chats.customer ? __props.item_chats.customer.name + "（" + __props.item_chats.customer.remark + ")" : __props.item_chats.user ? __props.item_chats.user.name : "") + " ", 1), _createElementVNode("span", {
        class: _normalizeClass(__props.item_chats.customer ? 'tag_1s' : 'tag_2s')
      }, _toDisplayString(__props.item_chats.customer ? "@微信" : __props.item_chats.user ? "@" + __props.item_chats.user.dept_name : ""), 3)]), _hoisted_8, _createElementVNode("div", {
        class: "refresh",
        onClick: _cache[0] || (_cache[0] = $event => get_refresh())
      }, _hoisted_11)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_TimePicker, {
        modelValue: selectedDateRange.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => selectedDateRange.value = $event)
      }, null, 8, ["modelValue"])]), _createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => activeName.value = $event),
        class: "demo-tabs",
        onTabClick: handleClick
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tag_list.value, (item, index) => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: index,
            name: item.id,
            label: item.name
          }, null, 8, ["name", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_14, [_createVNode(allchat, {
        ref_key: "allContainer",
        ref: allContainer,
        from: __props.from,
        page_f: __props.page_f,
        cha_id: props.cha_id,
        types: __props.types,
        activeName: activeName.value,
        selectedDateRange: selectedDateRange.value
      }, null, 8, ["from", "page_f", "cha_id", "types", "activeName", "selectedDateRange"])])]), ai_show.value ? (_openBlock(), _createBlock(_Transition, {
        key: 2,
        name: "dialog-zoom",
        onBeforeEnter: beforeEnter,
        onEnter: enter,
        onLeave: leave
      }, {
        default: _withCtx(() => [ai_show.value ? (_openBlock(), _createBlock(AiItem, {
          key: 0,
          "dialog-visible": ai_show.value,
          md5: __props.cha_id,
          from: __props.from,
          onCloseDialog: closeAi
        }, null, 8, ["dialog-visible", "md5", "from"])) : _createCommentVNode("", true)]),
        _: 1
      })) : _createCommentVNode("", true)]);
    };
  }
});